import { useTanStackQuery } from '@americanexpress/banking-common/tanstack';
import { READ_CUSTOMER_PRODUCTS_V2_ONE_DATA_FUNCTION } from '../constants';

export const useCustomerProducts = () => {
  const {
    data: customerProducts,
    isError,
    isLoading,
  } = useTanStackQuery({
    oneDataFunction: READ_CUSTOMER_PRODUCTS_V2_ONE_DATA_FUNCTION,
    fetchOptions: {
      body: JSON.stringify({}),
    },
  });

  return {
    customerProducts,
    isErrorOnCustomerProducts: isError,
    isLoadingCustomerProducts: isLoading,
  };
};
